import { render, staticRenderFns } from "./UserHomePage.vue?vue&type=template&id=22b5d161&scoped=true"
import script from "./UserHomePage.vue?vue&type=script&lang=js"
export * from "./UserHomePage.vue?vue&type=script&lang=js"
import style0 from "./UserHomePage.vue?vue&type=style&index=0&id=22b5d161&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5d161",
  null
  
)

export default component.exports